import { SegmentationConfig } from '../segmentationConfig.model';
import Tooltip from 'common/components/tooltip/tooltip-v2';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal, confirmModal, openModal } from 'features/modal/modalSlice';
import { useUpdateSegmentationConfigStatusMutation } from 'app/apis/commandApi';
import { RootState } from 'app/store';
import { addListener } from '@reduxjs/toolkit';
import { useNavigate, Link } from 'react-router-dom';
import {
  resetSegmentationConfig,
  selectSegmentationCategory,
  setSegmentationCategory
} from '../segmentation-config.slice';
import { TabKey } from '../segmentation-config-tab-keys';
import { ButtonTheme } from 'common/components/buttons/button-theme';

export interface SegmentationRuleConfigTableActionsProps {
  segmentationConfig: SegmentationConfig;
}

const SegmentationRuleConfigTableActions = ({
  segmentationConfig
}: SegmentationRuleConfigTableActionsProps) => {
  const dispatch = useDispatch();
  const { siteId } = useSelector((state: RootState) => state.selectedSite);

  const [deleteWebPageViewSegmentationConfig] =
    useUpdateSegmentationConfigStatusMutation();

  const segmentationCategory = useSelector(selectSegmentationCategory);

  const onDeleteWebPageViewSegmentationConfig = async () => {
    try {
      await deleteWebPageViewSegmentationConfig({
        siteId,
        configId: segmentationConfig.id,
        updatedConfigStatus: 1,
        category: segmentationCategory
      }).unwrap();
    } catch (error) {
      console.error('Failed to delete segmentation config:', error);
    }
  };

  const handleDelete = () => {
    dispatch(
      addListener({
        actionCreator: confirmModal,
        effect: async (action, listenerApi) => {
          listenerApi.cancelActiveListeners();

          await onDeleteWebPageViewSegmentationConfig();

          listenerApi.dispatch(closeModal());

          listenerApi.unsubscribe();
        }
      })
    );

    dispatch(
      openModal({
        modalProps: {
          title: 'Are you sure you want to delete this configuration?',
          content: 'This action cannot be undone.',
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          confirmButtonTheme: ButtonTheme.PRIMARY,
          cancelButtonTheme: ButtonTheme.CANCEL
        },

        modalType: 'deleteWebPageViewSegmentationConfig'
      })
    );
  };

  const activeTab = useSelector(selectSegmentationCategory) ?? TabKey.Forms;

  const handleEdit = () => {
    dispatch(resetSegmentationConfig());
    dispatch(setSegmentationCategory(activeTab));
  };

  return (
    <>
      <div className="text-sm w-full flex items-center justify-center">
        <Tooltip tooltipContent={<div className="whitespace-nowrap">Edit</div>}>
          <Link
            to={`/settings/segmentation-config/edit/${segmentationConfig.id}`}
            rel="noopener noreferrer"
            onClick={handleEdit}
          >
            <i className="ra-icons-generic-edit text-primary-700 pl-2 cursor-pointer"></i>
          </Link>
        </Tooltip>

        {/* <Tooltip
          tooltipContent={<div className="whitespace-nowrap">History</div>}
        >
          <i className="ra-icons-generic-page-1 text-primary-700 pl-1 cursor-pointer"></i>
        </Tooltip> */}

        <Tooltip
          tooltipContent={<div className="whitespace-nowrap">Delete</div>}
        >
          <i
            className={`ra-icons-generic-bin text-primary-700 pl-1 cursor-pointer`}
            onClick={handleDelete}
          ></i>
        </Tooltip>
      </div>
    </>
  );
};

export default SegmentationRuleConfigTableActions;
